import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Services from '../components/Services';
import Industries from '../components/Industries';
import Testimonials from '../components/Testimonials';
import { useTranslation } from 'react-i18next';

const ServicesPage = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Breadcrumb */}
      <div className="bg-gray-100 py-4">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-sm text-gray-600">
            <a href="/" className="text-blue-500 hover:underline">AP Pacific</a> &gt; {t('services.breadcrumb')}
          </div>
        </div>
      </div>

      {/* Page Header */}
      <div className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-gray-800">{t('services.pageTitle')}</h1>
        </div>
      </div>

      {/* Services Content */}
      <Services />

      {/* Areas We Service */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">{t('services.areasTitle')}</h2>
          <p className="text-gray-600 mb-4">
            {t('services.areasDescription')}
          </p>
          <p className="text-lg font-semibold text-blue-500">
            {t('services.cityArea')}
          </p>
        </div>
      </section>

      {/* Industries */}
      <Industries />
      
      {/* Testimonials */}
      <Testimonials />

      <Footer />
    </div>
  );
};

export default ServicesPage;